angular.module('TetherApp').controller('DrawController', [
    'ngToast',
    '$window',
    function (
        ngToast,
        $window
    ) {
        let self = this;

        self.hours = range(0, 23);
        self.minutes = range(0, 59);
        self.seconds = range(0, 59);

        self.init = function(start, end) {
            self.started_at = new Date(start);
            self.ended_at = new Date(end);
        }
    }
]);